import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const FastIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Fast - speedometer/motion lines */}
    <path d="M13 4l-1 6h5l-6 10 1-6H7l6-10" />
    <path d="M3 10h2" />
    <path d="M3 14h3" />
    <path d="M19 10h2" />
    <path d="M18 14h3" />
  </svg>
);
